const API_URL = process.env.REACT_APP_API_URL;
const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;

module.exports = { 
  API_URL,
  MIXPANEL_TOKEN
};